import moment from 'moment'
import { useContext } from 'react'
import * as SETTINGS from '../../../constants/settings'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import { clearPublicMessages } from '../../../utils/APIs/publicMessages'
import { toastError, toastSuccess } from '../../../utils/toast'
import Modal from '../../Utilities/Modal'

const ClearChatModal = ({ open, setOpen, clearChatPolicy }) => {
  const { updateSetting } = useContext(SiteConfigContext)

  const handleClearMessages = async () => {
    const policy = {
      ...clearChatPolicy,
      lastClearedAt: moment().utc().toISOString()
    }

    try {
      const updateSettingResponse = await updateSetting(
        SETTINGS.CLEAR_CHAT_POLICY,
        policy
      )

      if (
        !(
          updateSettingResponse.status >= 200 &&
          updateSettingResponse.status < 300
        )
      ) {
        throw new Error('Failed to update clear chat policy.')
      }
      const clearMessagesResponse = await clearPublicMessages()

      if (
        !(
          clearMessagesResponse.status >= 200 &&
          clearMessagesResponse.status < 300
        )
      ) {
        throw new Error('Failed to clear chat.')
      }
      toastSuccess('Chat cleared.')
    } catch (error) {
      toastError(error.message)
    }

    setOpen(false)
  }

  return (
    <Modal
      title="Clear Chat"
      open={open}
      setOpen={setOpen}
      confirmFunction={handleClearMessages}
      size="md"
    >
      <p>This will clear all public messages from chat for Subscribers.</p>
      <p>Moderators will still see all messages.</p>
    </Modal>
  )
}

export default ClearChatModal
